// extracted by mini-css-extract-plugin
export default {"updatePINSection":"update-pin_updatePINSection__ijMCU","btnDefault":"update-pin_btnDefault__1Lklx"};